import GroupsIcon from "@mui/icons-material/Groups";
import HolidayVillageIcon from "@mui/icons-material/HolidayVillage";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonIcon from "@mui/icons-material/Person";
import MapsHomeWorkIcon from "@mui/icons-material/MapsHomeWork";
import StackedLineChartIcon from "@mui/icons-material/StackedLineChart";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";

const globalOptions = [];

const headerOptions = {
  logged: [
    {
      title: "Inicio",
      icon: HolidayVillageIcon,
      route: "/",
      roles: ["inversor-individual", "admin"],
    },
//    {
//      title: "Inmuebles",
//      icon: MapsHomeWorkIcon,
//      route: "/property",
//      roles: ["inversor-individual"],
//    },
    {
      title: "Proyectos",
      icon: StackedLineChartIcon,
      route: "/projects",
      roles: ["inversor-individual"],
    },
    {
      title: "Cerrar Sesión",
      route: "/logout",
      icon: LogoutIcon,
    },
  ],
  default: [...globalOptions],
};

export default headerOptions;
